import React from 'react';
import { Select, Flex, Text } from '@chakra-ui/react';
import User from '../../api/user';

export function useOrgCompanies() {
  const userInfo = User.GetInfo();
  return userInfo?.organizationCompanies || [];
}

export function isOrgAdmin() {
  const userInfo = User.GetInfo();
  return Array.isArray(userInfo?.organizationCompanies) && userInfo.organizationCompanies.length > 0;
}

export default function OrgCompanySelector({ selectedCompanyId, onChange }) {
  const companies = useOrgCompanies();

  if (companies.length === 0) return null;

  return (
    <Flex align='center' ml='15px' mr='15px' gap='10px'>
      <Text fontSize='sm' fontWeight='600' whiteSpace='nowrap'>סנן לפי חברה:</Text>
      <Select
        size='sm'
        borderRadius='8px'
        value={selectedCompanyId || ''}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
        minW='160px'
      >
        <option value=''>כל החברות</option>
        {companies.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </Select>
    </Flex>
  );
}
